"use client";
import React, { createContext, ReactNode, FC, useContext, useMemo } from "react";
import { JuneSoComponentContextType, JuneSoEventPropsType } from "@stadium/services/june-analytics/prop-types.d";

const defaultObj = {};

export const JuneSoComponentContext = createContext<JuneSoComponentContextType>(defaultObj);

export const useJuneSoComponentContext = () => useContext(JuneSoComponentContext);

export const JuneSoComponentProvider: FC<{
  componentName: string;
  eventProperties?: JuneSoEventPropsType;
  children?: ReactNode;
}> = ({ componentName, eventProperties = defaultObj, children }) => {
  const value = useMemo(
    () => ({ componentName, eventProperties }),
    [componentName, eventProperties],
  );

  return (
    <JuneSoComponentContext.Provider value={value}>{children}</JuneSoComponentContext.Provider>
  );
};
